exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#founded_firms[data-v-432b0a5a] .firm{border-bottom:1px solid #d8d8d8;padding-top:15px;padding-bottom:15px}#founded_firms[data-v-432b0a5a] .address{font-weight:700}", ""]);

// exports
